import type { NavigationGuard, RouteLocationRaw } from 'vue-router';
import type { InvitationCountResponse } from '../types/referral.type';
import { referralService } from '../services/referral.service';
import { toast } from '@flash-global66/g-toast';

async function resolveReferralCount(): Promise<InvitationCountResponse | null> {
  const result = await referralService.getInvitationCount();
  return result.fold(
    (): InvitationCountResponse | null => null,
    (success) => success.data
  );
}

function createReferralGuard(redirectWhen: (totalReferrals: number) => boolean, redirectTo: RouteLocationRaw): NavigationGuard {
  return async () => {
    const levels = await referralService.getLevels();
    if (levels.isLeft()) {
      toast.error('Referidos no disponibles por ahora.');
      return { name: 'movements' };
    }
    const data = await resolveReferralCount();
    if (data === null) return redirectTo;
    if (redirectWhen(data.totalReferrals ?? 0)) return redirectTo;
    return true;
  };
}

export function createReferralDashboardGuard(): NavigationGuard {
  return createReferralGuard((total) => total === 0, { name: 'referral-landing' });
}

export function createReferralLandingGuard(): NavigationGuard {
  return createReferralGuard((total) => total > 0, { name: 'referral-dashboard' });
}
